import { combineReducers } from "redux";
import { projectReducer } from "./Project/reducer";
import { userReducer } from './User/reducer';
import { meetingReducer } from "./Meeting/reducer";
import { qualificationReducer } from "./Qualification/reducer"

export const combinedReducers = combineReducers({
    user: userReducer,
    meeting: meetingReducer,
    project: projectReducer,
    qualification: qualificationReducer,
  
});
